export const githubIconsPath =
  "https://raw.githubusercontent.com/bgd-labs/web3-icons/main";
